import { render, staticRenderFns } from "./orderbase.vue?vue&type=template&id=607f833b&scoped=true"
import script from "./orderbase.vue?vue&type=script&lang=js"
export * from "./orderbase.vue?vue&type=script&lang=js"
import style0 from "./orderbase.vue?vue&type=style&index=0&id=607f833b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607f833b",
  null
  
)

export default component.exports